/**
 *
 * @param {Object} object Object to sync with input
 * @param {HTMLInputElement|HTMLSelectElement} inputElement Input element to sync with object
 * @param {string} field Field to update on the given object
 * @param {string[]} events Events that should be listened for to trigger
 */
function syncInputValue(
	object,
	inputElement,
	field,
	events = [
		'keyup',
		'change',
	]
) {
	const handler = () => {
		if (inputElement.type === 'checkbox') {
			object[field] = inputElement.checked;
		} else {
			object[field] = inputElement.value;
		}
	}

	events.forEach(eventType => {
		// Jquery for better compatibility
		$(inputElement).on(eventType, handler);
	})

}

export {syncInputValue}
